// Format a Date object into YYYY-MM-DD (local time)
export const formatDate = (date) => {
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
};

// Format a Date object into YYYY-MM-DD (UTC time)
export const formatDateUTC = (date) => {
    const year = date.getUTCFullYear();
    const month = `0${date.getUTCMonth() + 1}`.slice(-2);
    const day = `0${date.getUTCDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
};

// Get default start date: 1st day of previous month (UTC)
export const getDefaultStartDate = () => {
    const now = new Date();
    const prevMonth = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1));
    return formatDateUTC(prevMonth);
};

// Get default end date: Last day of previous month (UTC)
export const getDefaultEndDate = () => {
    const now = new Date();
    const lastDayOfPrevMonth = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 0)); // 0 = last day of prev month
    return formatDateUTC(lastDayOfPrevMonth);
};
